import { FilterField, MainTab, SubTab, Composition } from './enum';
import { SearchType } from '@/constants/media';

export const DefaultParams = {
  [FilterField.BEGIN_TIME]: '',
  [FilterField.IMAGE_CATEGORY]: 0,
  [FilterField.CATEGORY_IDS]: '',
  [FilterField.COLOR]: '',
  [FilterField.EDITED]: 0,
  [FilterField.EDN_TIME]: '',
  [FilterField.ID]: '',
  [FilterField.IMAGE_TYPES]: '',
  [FilterField.LAYOUTS]: '',
  [FilterField.MERGE_SIMILAR]: 1,
  [FilterField.NO_OVERWRITES]: '',
  [FilterField.PAGE]: 1,
  [FilterField.REQUEST_ID]: '',
  [FilterField.SEARCH_ID]: '',
  [FilterField.SIZE]: 60,
  [FilterField.SORT_BY]: 1,
  [FilterField.TERM]: '',
  [FilterField.TYPE]: SearchType.IMAGE,
  [FilterField.VIDEO_FORMAT]: 0,
  [FilterField.XSRF_TOKEN]: '',
  [FilterField.ENABLE_INTERVENE]: true,
  [FilterField.FORMAT]: '',
  [FilterField.GENDER]: '',
  [FilterField.FACE_NUM]: '',
  [FilterField.RACIAL]: '',
  [FilterField.AGE]: '',
  [FilterField.IS_AIGC]: 'false',
  [FilterField.SOURCE]: '',
};

export const DefaultIntermediate = {
  [FilterField.CATEGORY_IDS]: [] as number[],
  [FilterField.COLOR]: '',
  [FilterField.IMAGE_TYPES]: [] as number[],
  [FilterField.LAYOUTS]: [] as number[],
  [FilterField.FORMAT]: [] as string[],
  [FilterField.FACE_NUM]: [] as string[],
  [FilterField.RACIAL]: [] as string[],
  [FilterField.AGE]: [] as string[],
  [FilterField.SOURCE]: [] as string[],
  main: MainTab.EditPicture,
  sub: SubTab.SINGLE,
};

export const DefaultTopicParams = {
  [FilterField.PAGE]: 1,
  [FilterField.SIZE]: 60,
};

export const ParamsKeys = new Set(Object.keys(DefaultParams));
export const IntermediateKeys = new Set(Object.keys(DefaultIntermediate));
export const PRICE_NO = new Set([
  0, 1, 5, 150, 200, 201, 300, 350, 351, 400, 500, 501, 600, 800, 1000, 1500,
  3500, 6000,
]);
export const AUTHORITY_ERR_NO = new Set([30601, 30701, 30702, 40015, 40016]);
export const VIDEO_AUTHORITY_ERR_NO = new Set([30601, 30701, 40015]);

/**
 * 从 image story topic
 * ----> 映射到 main sub
 */
export const getMainSub = {
  [SearchType.IMAGE]: {
    main: MainTab.EditPicture,
    sub: SubTab.SINGLE,
    compositionVisible: true,
    composition: Composition.GRID,
  },
  [SearchType.STORY]: {
    main: MainTab.EditPicture,
    sub: SubTab.STORY,
    compositionVisible: false,
    composition: Composition.GRID,
  },
  [SearchType.TOPIC]: {
    main: MainTab.EditPicture,
    sub: SubTab.TOPIC,
    compositionVisible: false,
    composition: Composition.GRID,
  },
  [SearchType.CREATIVE]: {
    main: MainTab.CreativePicture,
    sub: SubTab.SINGLE,
    compositionVisible: true,
    composition: Composition.ADAPT,
  },
  [SearchType.VIDEO]: {
    main: MainTab.EditVideo,
    sub: SubTab.SINGLE,
    compositionVisible: true,
    composition: Composition.GRID,
  },
  [SearchType.VIDEO_STORY]: {
    main: MainTab.EditVideo,
    sub: SubTab.STORY,
    compositionVisible: true,
    composition: Composition.GRID,
  },
};
